<template>
  <div class="message_wrap">
    <div class="flex-cc message_content_wrap">
      <div class="message_content flex-cc">
          <div class="tip_info">
            {{ nowYear }}年考级报名统一使用“江苏音协”APP进行报名
          </div>
        <div class="header_down">下载方式</div>
        <div class="content_info">
             <p>1、苹果手机用户请通过app store，搜索“江苏音协“下载。</p>
        <p>2、安卓手机用户直接扫描下方二维码，即可下载。</p>
        </div>
        <div class="flex-cc pic_part">
            <img src="../../static/img/musicians.png" alt >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import backgroundVue from "@/components/Background.vue";
export default {
  components: {
    backgroundVue
  },
  data() {
    return {
      nowYear: new Date().getFullYear()
    };
  }
};
</script>
<style lang="less" >
// @import "../../static/less/bg.less";
.message_wrap {
  .message_content_wrap {
    line-height: 28px;
    font-size: 14px;
    color: #666;
    position: absolute;
    height: 100%;
    width: 100%;
    background: #eeeae7
      url(data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/2wBDAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/2wBDAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/wAARCAO2AAIDAREAAhEBAxEB/8QAGgABAAMAAwAAAAAAAAAAAAAAAAECAwQFCv/EACYQAQABAgQEBwAAAAAAAAAAAAABERICUWGRcaGx0QQVIVJTktL/xAAaAQEBAQEAAwAAAAAAAAAAAAAAAwECBQYH/8QAJBEBAAAFAwMFAAAAAAAAAAAAAAEREmGRAlGhBbHhFlRxktH/2gAMAwEAAhEDEQA/APaN51475cX2x93xz0/0z2+j66fx7Q6l5sAARWM43ZOG8MjBAAAAAAAAAAAAAAARXjtIMaxlHPuCAAARWM4BW7hz/IHp7qcMQLU16dgSAADWyNQTbri3BNIyjYEgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA2tw5dVZaLZ8izinVt2BYAFKL8C9k6KDURq1b9hso7Rw5FxyAWtxZKz0WwNmUX48goAAClF+AUAF7J0HFcLtVKL8JCgAAO6I2BUAAb0jKNhCcd45SMAGyjtHALS+cxBoAAAAAAAAAAAAAAAA//Z)
      repeat-x;
  }

  .flex-cc {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .message_content {
    flex-direction: column;
    align-self: center;
    .tip_info{
        font-weight: 700;
        font-size: 16px;
        padding-bottom: 20px;
    }
    .header_down {
        color: #fff;
      padding: 1px 15px;
      border-radius:  15px 0 15px 0;
      background-image: linear-gradient(
        to right,
        rgb(141, 185, 252),
        rgb(164, 88, 264)
      );
    }
    .content_info{
        margin: 20px 0;
    }
    .pic_part{
        // padding-top: 20px;
        img{
            width: 150px;
        }
    }
  }
}
</style>


   


// WEBPACK FOOTER //
// src/views/message.vue